export default "__VITE_ASSET__BNq$ALk7__"